import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { InfoIconModule } from '../../atoms/info-icon/info-icon.module';
import { HelpIconModule } from '../../molecules/help-icon/help-icon.module';
import { InputComponent } from './input.component';

@NgModule({
  declarations: [InputComponent],
  imports: [
    CommonModule,
    FormsModule,
    HelpIconModule,
    ErrorTooltipModule,
    InfoIconModule
  ],
  exports: [InputComponent]
})
export class InputModule {}
